"use client"

import { NpHomePageRatingData } from "src/components/home/types"
import { NpReviewStars } from "src/components/np-design/components/NpReviewStars"
import { formatDateAgo } from "src/utilities/dateFormatting"

export type NpReviewProps = {
  review: NpHomePageRatingData
}

export const NpReview = ({ review }: NpReviewProps) => {
  return (
    <div className="border-np-green25 embla__slide_content flex h-full flex-col items-start gap-4 border-y p-6">
      <NpReviewStars stars={review.stars} />
      <div>{review.text}</div>
      {review.timestamp && <div>{formatDateAgo(review.timestamp)}</div>}
    </div>
  )
}
